import {
  useQueries,
  keepPreviousData,
  UseQueryResult,
} from "@tanstack/react-query";
import {
  AccountsApiBalancesRequest,
  balances,
  CACHE_KEYS,
  DateValuePairList,
} from "@rentablo/api/apiv1";
import {
  groupByAccountAndCurrency,
  QueriesByAccount,
  QuerySpec,
} from "./querySpecs";

export const useBalanceQueries = (
  specs: QuerySpec[],
  accessToken: string | undefined
): QueriesByAccount<DateValuePairList> => {
  const results = useQueries({
    queries: specs.map((spec) => {
      const params: AccountsApiBalancesRequest = {
        id: [spec.accountId],
        displayCurrency: spec.displayCurrency,
      };
      return {
        queryKey: [CACHE_KEYS.BALANCES, params],
        queryFn: (): Promise<DateValuePairList> =>
          balances(accessToken, params),
        enabled: !!accessToken,
        staleTime: Infinity,
        placeholderData: keepPreviousData,
      };
    }),
  });

  return groupByAccountAndCurrency(
    specs,
    results as UseQueryResult<DateValuePairList, unknown>[]
  );
};
